import Vue from "vue";
import ApiService from "@/common/api.service";
import { API_PATH } from "@/common/config";

const PATH = "pipelines";

export const CREATE_PIPELINE = "createPipeline";
export const GET_PIPELINE = "getPipeline";
export const GET_PIPELINES = "getPipelines";
export const GET_PIPELINE_OPTIONS = "getPipelineOptions";
export const UPDATE_PIPELINE = "updatePipeline";
export const DELETE_PIPELINE = "deletePipeline";
export const REORDER_PIPELINE_DEALS = "reorderPipelineDeals";
const SET_PIPELINE_OPTIONS = "setPipelineOptions";

const state = {
  pipelineOptions: [],
};

const getters = {
  pipelineOptions(state) {
    return state.pipelineOptions;
  },
};

const actions = {
  [GET_PIPELINE_OPTIONS]({ commit }, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/options`, params)
        .then(({ data }) => {
          commit(SET_PIPELINE_OPTIONS, data.data || []);
          resolve(data);
        })
        .catch(({ response }) => {
          commit(SET_PIPELINE_OPTIONS, []);
          reject(response.data);
        });
    });
  },

  [GET_PIPELINES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [GET_PIPELINE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [CREATE_PIPELINE](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [UPDATE_PIPELINE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [DELETE_PIPELINE](context, id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(`${API_PATH}${PATH}/${id}`)
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error?.response?.data ?? error);
        });
    });
  },

  [REORDER_PIPELINE_DEALS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.pipelineId}/deals/reorder`, {
        stages: payload.stages,
      })
        .then(() => {
          resolve(true);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },
};

const mutations = {
  [SET_PIPELINE_OPTIONS](state, pipelineOptions) {
    state.pipelineOptions = pipelineOptions;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
